module.exports = __webpack_public_path__ + "img/colorLogo.3b0046d4.svg";